import {useCallback, useEffect} from 'react';

import {useEnvContext} from '@web-landing/components/EnvContext/EnvContextProvider';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {emitEcommerceSelectAppEventWithCookie} from '@web-landing/analytics/emitEcommerceSelectAppEventWithCookie';
import {EVENTS} from '@web-landing/analytics/events';

const config = {
  MiniPicks: {
    compilation_id: 'landing_app_compilation_ONsKg2',
    listName: 'Найди любимое приложение',
  },
  GamesMonth: {
    compilation_id: 'landing_app_compilation_SDpLr4',
    listName: 'Игры месяца',
  },
};

export const usePicksAnalytics = (
  isPicksVisible: boolean,
  setIsPicksVisible: (param: boolean) => void,
  metricsName: 'GamesMonth' | 'MiniPicks',
) => {
  const {cookieDomain} = useEnvContext();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsPicksVisible(true);
          } else {
            setIsPicksVisible(false);
          }
        });
      },
      {
        root: null,
        threshold: 0.25,
      },
    );

    const element = document.getElementById('picks');

    if (!element) {
      return;
    }

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [setIsPicksVisible]);

  const landingRecommendedAppsViewAnalytics = useCallback(() => {
    if (isPicksVisible) {
      logTmrEvent(EVENTS.landingRecommendedAppsView, {
        compilation_type: 'grid',
        compilation_id: config[metricsName].compilation_id,
      });
    }
  }, [isPicksVisible, metricsName]);

  const appSelectAnalytics = useCallback(
    (appId: number, appName: string, appNum: number, packageName: string) => {
      logTmrEvent(EVENTS.appSelect, {
        app_id: appId,
        app_name: appName,
        app_num: appNum,
        compilation_id: config[metricsName].compilation_id,
        compilation_type: 'grid',
        position: appNum,
        app_packageName: packageName,
        compilation_name: config[metricsName].listName,
      });

      emitEcommerceSelectAppEventWithCookie({
        appId,
        packageName,
        listName: config[metricsName].listName,
        position: appNum,
        cookieDomain,
      });
    },
    [cookieDomain, metricsName],
  );

  return [landingRecommendedAppsViewAnalytics, appSelectAnalytics] as const;
};
